import React from 'react';
import * as THREE from 'three';
import { PalmTree, BushyTree, StadiumMelaka, EntranceArchway, TreeLine, Carpark } from './VenueDecorations';

/**
 * Renders any landmark from the DB in the 3D scene.
 * Supported types: stadium | carpark | tree_line | archway | palm | tree | bush | building
 */
export function LandmarkRenderer({ landmark }) {
  const pos = [landmark.position_x || 0, landmark.position_y || 0, landmark.position_z || 0];
  const rot = [0, ((landmark.rotation || 0) * Math.PI) / 180, 0];
  const scale = landmark.scale || 1;

  switch (landmark.type) {
    case 'stadium':
      return (
        <group position={pos} rotation={rot} scale={scale}>
          <StadiumMelaka position={[0, 0, 0]} />
        </group>
      );

    case 'carpark':
      return (
        <group position={pos} rotation={rot}>
          <Carpark
            position={[0, 0, 0]}
            width={landmark.width || 190}
            depth={landmark.depth || 75}
          />
        </group>
      );

    case 'tree_line': {
      // Convert center-based rect (position_x, position_z, width, depth) to xMin..xMax + zStart..zEnd
      const w = landmark.width || 190;
      const d = landmark.depth || 15;
      const zCenter = landmark.position_z || 0;
      const xCenter = landmark.position_x || 0;
      return (
        <TreeLine
          zStart={zCenter + d / 2}
          zEnd={zCenter - d / 2}
          xMin={xCenter - w / 2}
          xMax={xCenter + w / 2}
        />
      );
    }

    case 'archway':
      return (
        <group position={pos} rotation={rot} scale={scale}>
          <EntranceArchway position={[0, 0, 0]} />
        </group>
      );

    case 'palm':
      return <PalmTree position={pos} scale={scale} />;

    case 'tree':
      return <BushyTree position={pos} scale={scale} />;

    case 'bush':
      return (
        <group position={pos} scale={scale}>
          <mesh position={[0, 0.4, 0]} castShadow>
            <sphereGeometry args={[0.9, 8, 8]} />
            <meshStandardMaterial color={landmark.color || '#22c55e'} roughness={0.9} />
          </mesh>
        </group>
      );

    case 'building':
      // Buildings removed per user request — only stadium is kept as venue landmark.
      return null;

    default:
      return null;
  }
}
